import { useMemo, useRef } from 'react'
import * as THREE from 'three'
import { useTexture } from '@react-three/drei'

export default function FadingGround() {
  const meshRef = useRef()
  
  // Load ground textures
  const baseColor = useTexture('/textures/ground/Ground_BaseColor.webp')

  // Set correct color space for base color texture
  useMemo(() => {
    baseColor.colorSpace = THREE.SRGBColorSpace
    baseColor.flipY = false
  }, [baseColor])

  // Generate radial gradient alpha map for edge fading
  const alphaMap = useMemo(() => {
    const size = 512
    const canvas = document.createElement('canvas')
    canvas.width = size
    canvas.height = size
    const ctx = canvas.getContext('2d')

    const centerX = size / 2
    const centerY = size / 2
    const radius = size / 2

    // Create radial gradient
    const gradient = ctx.createRadialGradient(centerX, centerY, 0, centerX, centerY, radius)
    gradient.addColorStop(0, 'white')      // Fully opaque at center
    gradient.addColorStop(0.7, 'white')    // Stay opaque until 70%
    gradient.addColorStop(1, 'black')      // Fade to transparent at edges

    ctx.fillStyle = gradient
    ctx.fillRect(0, 0, size, size)

    const tex = new THREE.CanvasTexture(canvas)
    tex.needsUpdate = true
    return tex
  }, [])

  return (
    <>
    <mesh ref={meshRef} rotation={[Math.PI / 2, 0, 0.9]} position={[0, -1.32, 0]}  receiveShadow renderOrder={0}>
      <circleGeometry args={[260, 64]} />
      <meshStandardMaterial
        map={baseColor}
        alphaMap={alphaMap}
        transparent={true}
        color={new THREE.Color().setScalar(0.55)}
        side={THREE.BackSide}
      />
    </mesh>
    <mesh ref={meshRef} rotation={[Math.PI / 2, 0, 0]} position={[-15, -1.31, -15]}  receiveShadow renderOrder={1}>
      <circleGeometry args={[50, 64]} />
      <meshStandardMaterial
        map={baseColor}
        alphaMap={alphaMap}
        transparent={true}
        color={new THREE.Color().setScalar(0.55)}
        side={THREE.BackSide}
      />
    </mesh>
    </>
  )
}